import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/profiles/error.tsx");
